var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUeberblick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberblick__Icn/40px/Ueberblick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberblick__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Ueberblick__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,8 C24.418278,8 28.418278,10.3333333 32,15 C28.418278,19.6666667 24.418278,22 20,22 C15.581722,22 11.581722,19.6666667 8,15 C11.581722,10.3333333 15.581722,8 20,8 Z M20,10 C16.6889677,10 13.6074462,11.5768187 10.7023989,14.860897 L10.581,15 L10.7023989,15.139103 C13.513735,18.3172433 16.4903435,19.8964932 19.6802922,19.9950732 L20,20 C23.3110323,20 26.3925538,18.4231813 29.2976011,15.139103 L29.418,15 L29.2976011,14.860897 C26.486265,11.6827567 23.5096565,10.1035068 20.3197078,10.0049268 L20,10 Z M20,11 C22.209139,11 24,12.790861 24,15 C24,17.209139 22.209139,19 20,19 C17.790861,19 16,17.209139 16,15 C16,12.790861 17.790861,11 20,11 Z M20,13 C18.8954305,13 18,13.8954305 18,15 C18,16.1045695 18.8954305,17 20,17 C21.1045695,17 22,16.1045695 22,15 C22,13.8954305 21.1045695,13 20,13 Z M27.013737,24 L12.986263,24 C12.8307079,24 12.6772978,24.0362895 12.538229,24.1059835 L6.55196597,27.1059835 C5.6090225,27.5785371 5.94527286,29 7,29 L33,29 C34.0547271,29 34.3909775,27.5785371 33.448034,27.1059835 L27.461771,24.1059835 C27.3227022,24.0362895 27.1692921,24 27.013737,24 Z M26.777,26 L28.772,27 L11.227,27 L13.222,26 L26.777,26 Z",
    id: ".._.._src_svg_Icn_40px_Ueberblick__Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberblick__Icn/40px/Plus-Tools",
    transform: "matrix(-1 0 0 1 40 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Ueberblick__Rectangle"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUeberblick);
export default __webpack_public_path__ + "static/media/Ueberblick.11d55e6096d042d44e5849777c658079.svg";
export { ForwardRef as ReactComponent };